module.exports = __webpack_public_path__ + "assets/img/thumb-Artboard-1-copy-31.5779898d.webp";